export default __webpack_public_path__ + "static/media/en.503f3edd.svg";